/**
 * @desc splitBox
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.fulfilment.SplitBoxRequestParamDto>, options?: any) {
  return updateResponse(
    http(URL + `/Batch/splitBox`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
